module.exports = __webpack_public_path__ + "img/talron-back.be2f0976.svg";